import { render } from "./SekretariatOPD.vue?vue&type=template&id=4b2ca98d"
import script from "./SekretariatOPD.vue?vue&type=script&lang=js"
export * from "./SekretariatOPD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__